module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp23_5010.b46a5ed0.png";